import { HttpsCallable, HttpsCallableOptions, httpsCallableFromURL } from 'firebase/functions'
import { firebase_functions } from '../common/firebaseConfig'

const HOSTING_ORIGIN =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://pattern-builder.web.app'
    : 'https://pattern-builder-dev.web.app'

/** Same-origin when served from Hosting (rewrites are CORS-free); absolute dev/prod Hosting origin from localhost. */
export const API_BASE =
  typeof window !== 'undefined' && window.location.hostname !== 'localhost'
    ? window.location.origin
    : HOSTING_ORIGIN

/**
 * Strangler-facade callable reference. Always calls through /api/<name>; the Hosting rewrite
 * decides whether the old Cloud Function or gc-api serves it (server-side flip, roadmap Phase 1).
 */
export function callableRef<Req = unknown, Res = unknown>(
  name: string,
  options?: HttpsCallableOptions
): HttpsCallable<Req, Res> {
  return httpsCallableFromURL<Req, Res>(firebase_functions, API_BASE + '/api/' + name, options)
}
